export default {"src":"/_next/static/media/carFullCircle_40.2465fd85.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};